export const DefaultAutoDismissMs = 3000;
